module.exports = __webpack_public_path__ + "static/media/forti.b762419c.jpg";